


























































import { cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../components/Pi/index'
import { FieldData } from '../../../../../../components/Pi/types'
import BusinessRegistrationIDocumentIcon
  from '../components/BusinessRegistrationIDocumentIcon.vue'
import { CompanyData, CompanyRegistrationStep } from '../types'

@Component({
  components: {
    BusinessRegistrationIDocumentIcon,
    ValidationObserver,
  },

  data: () => ({
    CompanyRegistrationStep,
  }),
})
export default class PowerOfAttorney extends Mixins<UseFields>(UseFields) {
  @Prop() readonly value!: CompanyData

  get companyData(): CompanyData {
    return cloneDeep(this.value)
  }

  inputConfigSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      this.$set(args.model, args.key as string, value)
    }

    return args
  }

  @Emit()
  input(): CompanyData {
    return this.companyData
  }

  @Emit()
  next(): { step: CompanyRegistrationStep } {
    return { step: CompanyRegistrationStep.CompanyDataFilling }
  }

  onNextButtonClick(): void {
    this.input()
    this.next()
  }
}
